'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var LabelParts = require('../common/LabelParts');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var CheckItem = require('../common/CheckBoxItem');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/*
 * 复选框组组件
 */

var CheckBoxGroup = React.createClass({

  getInitialState: function () {
    var TextUtil = util.Text;
    var text = TextUtil.removeLastEmptyRow(this.props.text);
    var items = TextUtil.delimitText(text,util.Text.DM_RETURN);
    var i;
    var itemText;
    var cfg;
    var state = {};
    for (i = 0; i < items.length; i++) {
      itemText = items[i];
      cfg = this.parseState(itemText);
      state[i] = {isChecked : cfg.isChecked,isDisabled : cfg.isDisabled};
    }
    return state;
  },

  parseItem: function (itemText) {

    var item = JSON.parse(JSON.stringify(this.props));
    var cfg;
    cfg = this.parseState(itemText);
    item.text = cfg.text;
    item.state = cfg.state;
    item.gap = 5;
    return item;
  },

  parseState: function (text) {
    var state = appTypes.ComStatus.ENABLE;
    var cutText = '';
    text = text.trim();
    if (text.indexOf('[]') === 0) {
      cutText = '[]';
      state = appTypes.ComStatus.ENABLE;
    } else if (text.indexOf('[ ]') === 0) {
      state = appTypes.ComStatus.ENABLE;
      cutText = '[ ]';
      text = text.replace('[ ]', '');
    } else if (text.indexOf('[x]') === 0) {
      cutText = '[x]';
      state = appTypes.ComStatus.SELECTED;
    }else if (text.indexOf('[X]') === 0) {
      cutText = '[X]';
      state = appTypes.ComStatus.SELECTED;
    } else if (text.charAt(0) === '-' && text.charAt(text.length - 1) === '-') {
      text = text.substring(1, text.length - 1);
      state = appTypes.ComStatus.DISABLED;
      if (text.indexOf('[x]') === 0) {
        state = appTypes.ComStatus.SELECTED_AND_DISABLED;
        cutText = '[x]';
      }if (text.indexOf('[X]') === 0) {
        state = appTypes.ComStatus.SELECTED_AND_DISABLED;
        cutText = '[X]';
      } else if (text.indexOf('[]') === 0) {
        cutText = '[]';
      } else if (text.indexOf('[ ]') === 0) {
        cutText = '[ ]';
      }
    }
    text = text.replace(cutText,'');
    return {
      isChecked: appTypes.ComStatus.isSelected(state),
      isDisabled: appTypes.ComStatus.isDisabled(state),
      text: text,
      state: state
    };
  },

  parseItems: function () {
    var TextUtil = util.Text;
    var text = TextUtil.removeLastEmptyRow(styleHelper.getText(this.props));
    var textArray = TextUtil.delimitText(text,TextUtil.DM_RETURN);
    var i;
    var itemText;
    var resultArray = [];
    var links = this.props.links.link;
    var link;
    var item;
    var rect;
    for (i = 0; i < textArray.length; i++) {
      itemText = textArray[i].trim();
      item = this.parseItem(itemText);
      link = links[i];
      rect = link.area.coords;
      item.x = rect.left;
      item.y = rect.top;
      item.w = rect.width;
      item.h = rect.height;
      delete item.currentX;
      delete item.currentY;
      delete item.currentW;
      delete item.currentH;
      resultArray.push(item);
    }

    return resultArray;
  },

  render: function () {
    var itemArray = this.parseItems();
    var itemStyle;
    var style = styleHelper.StyleUtil(this.props).default({overflow: 'hidden',position:'absolute'}).size().text().align().style;
    return (
      <div style={style}>
        {

          itemArray.map(function (item, index) {
            item.isChecked = this.state[index].isChecked;
            item.isDisabled = this.state[index].isDisabled;
            item.enabled = !item.isDisabled;
            itemStyle = styleHelper.StyleUtil(item).default({position: 'absolute',pointerEvent:item.isDisabled?'none':'auto'}).bounds().style;
            return (<div key={index} style={itemStyle}><CheckItem {...item}/></div>);
          }, this)
        }
      </div>

    );
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).on('checkedChange', this.onItemCheckedChange);
  },

  onItemCheckedChange: function (e, data) {
    var cfg = this.state[data.index];
    var state = this.state;
    var evt = data.nativeEvent;
    if(!cfg.isDisabled) {
      this.props.events.doSelfChecked(evt,this.props, !cfg.isChecked, data.key,data.index);
      cfg.isChecked = !cfg.isChecked;
      state[data.index] = cfg;
      this.setState(state);
    }
  },

  _onChecked : function(){

  }
});


module.exports = CheckBoxGroup;



// WEBPACK FOOTER //
// ./src/views/Components/CheckboxGroup.jsx